import { ProductListStoryblok } from '../types/generated-storyblok';
import { ProductList } from './Content/ProductList';

interface Blok extends ProductListStoryblok {
  analytics?: Analytics;
}

interface ContentBlockProductsProps {
  blok: Blok;
}

export const ContentBlockProducts = ({ blok }: ContentBlockProductsProps) => (
  <ProductList analytics={blok.analytics} blok={blok} className="w-full" />
);
